export interface DemoSavedSearchCriteria {
  min_price?: number | null;
  max_price?: number | null;
  selected_bedrooms?: string[];
  min_sqft?: number | null;
  available_only?: boolean;
  amenities?: string[];
  neighborhoods?: string[];
  price_per_sqft_max?: number | null;
  sort_by?: string;
  move_in_date?: string | null;
  selected_unit_ids?: string[];
}

export interface DemoSavedSearchPreset {
  id: string;
  name: string;
  client: string;
  criteria: string;
  color: string;
  searchCriteria: DemoSavedSearchCriteria;
}

export const DEMO_SAVED_SEARCHES: DemoSavedSearchPreset[] = [
  {
    id: "demo-midtown-1br",
    name: "Midtown 1BR under $2.2k",
    client: "Jane Demo",
    criteria: "1 Bed · $1,500–$2,200 · Midtown",
    color: "#0EA5E9",
    searchCriteria: {
      min_price: 1500,
      max_price: 2200,
      selected_bedrooms: ["1"],
      available_only: true,
      amenities: [],
      neighborhoods: ["Midtown"],
      sort_by: "price",
    },
  },
  {
    id: "demo-buckhead-studios",
    name: "Buckhead Studios",
    client: "Jane Demo",
    criteria: "Studio · $1,200–$1,600 · Buckhead",
    color: "#8B5CF6",
    searchCriteria: {
      min_price: 1200,
      max_price: 1600,
      selected_bedrooms: ["0"],
      available_only: true,
      amenities: [],
      neighborhoods: ["Buckhead"],
      sort_by: "price",
    },
  },
];
